var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-tabs', {
    staticClass: "mt-4"
  }, [_c('b-tab', {
    attrs: {
      "title": "General"
    }
  }, [_c('GeneralInformation')], 1), _c('b-tab', {
    attrs: {
      "title": "Change Password"
    }
  }, [_c('ChangePassword')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }